import { ActionCreator } from 'redux';
import { ThunkAction, Dispatch } from '../../../../types/actions';
import { TBoardId } from '../../../../types/types';
import { IGetState } from '../../../../types/types';
import { getEpicIds } from '../selectors/getEpicIds';
import { listViewActionSet } from '../store/listView/actions/listViewActionSet';
import { collapsedGroupsSetAction } from '../store/listViewBoard/actions/collapsedGroupsSet';
import { setLocalStorageItem } from '../helpers/setLocalStorageItem';
import { groupsToggleGoogleAnalyticsEvents } from './googleAnalyticsEvents';

export const groupsCollapse: ActionCreator<ThunkAction> = (
    boardId: TBoardId
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const epicIds = getEpicIds(state, boardId);
        dispatch(listViewActionSet(boardId, collapsedGroupsSetAction(epicIds)));
        dispatch(groupsToggleGoogleAnalyticsEvents(true));
        setLocalStorageItem(boardId);
    };
    return action;
};
